import { personaCfg } from 'config'
export default personaCfg
